import { TextLanguage } from "Store/texts/interfaces";
import { ProductBackendName } from "../../Products/productTypes";

export const getHeader = (
  productBackendName: ProductBackendName,
  userIdentificationEntity: any,
  tileTexts: any,
  lang: TextLanguage,
): string => {
  const customerFirstName =
    userIdentificationEntity.current?.newCustomerResponse?.providedPersonInfo
      ?.name?.firstName ?? "";

  switch (productBackendName) {
    case ProductBackendName.CHILD:
    case ProductBackendName.HEALTH:
    case ProductBackendName.PREGNANT_AND_NEWBORN:
    case ProductBackendName.TRAVEL:
    case ProductBackendName.AKA_TRAVEL:
      return `${tileTexts.header[lang]} ${customerFirstName}`;
    default:
      return tileTexts[productBackendName]?.[lang] ?? "";
  }
};
